// extracted by mini-css-extract-plugin
export default {"wrapper":"_1efbd92b","fixedHeight":"_48330b51","inline":"_baf93eb1","inlineSpinner":"_daa7158c","isStatic":"_763e991a"};